/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as MsDyn365 from '@msdyn365-commerce/core';
import { Node } from '@msdyn365-commerce-modules/utilities';
import { ISzfBusinessOpFormViewProps } from './szf-business-op-form';
// import { handleUpload } from './../../utilities/szf-utils';
import {
    Form,
    Input,
    FormGroup,
    Label,
    Button,
    // Spinner,
    FormFeedback,
    InputGroup,
} from 'reactstrap';
import { MoonLoader } from 'react-spinners';
import PhoneInput from 'react-phone-input-2';
import arabicLocale from 'react-phone-input-2/lang/ar.json';
import { ISzfBOCategoriesData } from './szf-business-op-form.props.autogenerated';
import Multiselect from 'multiselect-react-dropdown';

import existingContactDataAction, { GetExistingContactInput } from './../../actions/get-existing-contact.action';
import createNewContactDataAction, { PostNewContactInput } from './../../actions/post-new-contact.action';
import BOCaseDataAction, { PostBusinessOpCaseInput } from './../../actions/post-business-op-case.action';
import { IcountryCodeInput, INewContactCreation } from './../szf-contact-us/szf-contact-us.view';
import SZFModal from '../../utilities/szf-modal.component';
export interface IPostContactUsFormInput {
    fullName: string;
    organizationName: string;
    email: string;
    countryCode: string;
    phone: string;
    previousParticipant: string;
    previousParticipantType: string;
    hearAbout: string;
    others: string;
    categories: number;

    enableFullNameError: boolean;
    enableOrganizationNameError: boolean;
    enableEmailError: boolean;
    enablePhoneError: boolean;
    enablePreviousParticipantError: boolean;
    enablePreviousParticipantTypeError: boolean;
    enableHearAboutError: boolean;
    enableOthersError: boolean;
    enableTradeLicenseFileError: boolean;
    enablePresentationFileError: boolean;
    enableCategoriesError: boolean;

    enablePavilionsFields: boolean;
    enableProductsFields: boolean;
    enableRestaurantsFields: boolean;
    enableKiosksFields: boolean;
    enableServiceFields: boolean;
    enableGovernmentEntities: boolean;
    enableSponsor: boolean;

    listOfCountryPavilions: string[];
    typeOfProducts: number[];
    listOfGovernmentEntities: string[];
    typeOfSponsor: string;
    typeOfRestaurantsCoffeeShops: string;
    typeOfKiosksFoodTrucks: string;
    kioskActivity: string;
    serviceActivity: string;

    enableGovernmentEntitiesError: boolean;
    enableSponsorError: boolean;
    enablePavilionsError: boolean;
    enableProductsError: boolean;
    enableRestaurantsError: boolean;
    enableKiosksError: boolean;
    enableKioskActivityError: boolean;
    enableServiceError: boolean;
    enableDescriptionError: boolean;
    description: string;
    updateNpromotion: boolean;
}
export interface IPostBOInput extends IPostContactUsFormInput {
    tradeLicenseFile: File | undefined;
    presentationFile: File | undefined;
    tradeLicensefileBase64Code: string | ArrayBuffer | null | undefined;
    presentationfileBase64Code: string | ArrayBuffer | null | undefined;
    CRMtoken: string | undefined;
    contactID: string | undefined;
}
export interface IPavilionsOptionType {
    value: number;
    name: string;
    id: string;
}
export default (props: ISzfBusinessOpFormViewProps) => {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState(false);
    const [state, setState] = React.useState<IPostContactUsFormInput>({
        fullName: '',
        organizationName: '',
        email: '',
        countryCode: '',
        phone: '',
        previousParticipant: '',
        previousParticipantType: '',
        hearAbout: '',
        others: '',
        categories: 0,

        enableFullNameError: false,
        enableOrganizationNameError: false,
        enableEmailError: false,
        enablePhoneError: false,
        enablePreviousParticipantError: false,
        enablePreviousParticipantTypeError: false,
        enableHearAboutError: false,
        enableOthersError: false,
        enableTradeLicenseFileError: false,
        enablePresentationFileError: false,
        enableCategoriesError: false,

        enablePavilionsFields: false,
        enableProductsFields: false,
        enableRestaurantsFields: false,
        enableKiosksFields: false,
        enableServiceFields: false,
        listOfCountryPavilions: [],
        typeOfProducts: [],
        enableGovernmentEntities: false,
        enableSponsor: false,
        listOfGovernmentEntities: [],
        typeOfSponsor: '',
        typeOfRestaurantsCoffeeShops: '',
        typeOfKiosksFoodTrucks: '',
        kioskActivity: '',
        serviceActivity: '',

        enableGovernmentEntitiesError: false,
        enableSponsorError: false,
        enablePavilionsError: false,
        enableProductsError: false,
        enableRestaurantsError: false,
        enableKiosksError: false,
        enableKioskActivityError: false,
        enableServiceError: false,
        enableDescriptionError: false,
        description: '',
        updateNpromotion: false,
    });
    const tradeLicenseFileRef = React.useRef<HTMLInputElement>(null);
    const presentationFileRef = React.useRef<HTMLInputElement>(null);
    const [tradeLicenseFile, settradeLicenseFile] = React.useState<File | undefined>();
    const [presentationFile, setPresentationFile] = React.useState<File | undefined>();
    const multiselectRef = React.useRef<any>();
    const [BOError, setBOError] = React.useState('');
    const [BOInvalidOrEmptyError, setBOInvalidOrEmptyError] = React.useState('');
    const [tradeLicensefileBase64Code, setTradeLicenseFileBase64Code] = React.useState<string | ArrayBuffer | null>();
    const [presentationfileBase64Code, setPresentationFileBase64Code] = React.useState<string | ArrayBuffer | null>();
    // const termAndConditionCheckboxLabel = props.config.boTermAndConditionCheckboxLabel;
    const updateAndPromotionCheckboxLabel = props.config.boUpdateAndPromotionCheckboxLabel;
    const {
        boFullnameLabel,
        boOrganizationNameLabel,
        boPhoneLabel,
        boEmailLabel,
        boPreviousParticipationSelectLabel,
        boPreviousParticipationTypeLabel,
        boHearAboutSelectLabel,
        boOtherLabel,
        boTradeLicenseFileLabel,
        boPresentationFileLabel,
        boCategoriesSelectLabel,
        // boSubCategoriesSelectLabel,
        boDescriptionLabel,
        boSubmitButtonLabel,
        boOrganizeCountryPavilionsLabel,
        boShopCountryPavilionsLabel,
        boProductTypeLabel,
        boRestaurantShopTypeLabel,
        boKiosksTypeLabel,
        boKiosksActivityLabel,
        boServiceActivityLabel,
        governmentEntitiesLabel,
        sponsorLabel,
    } = props.config;
    const locale = props.context.request.locale;
    const fileSize = props.config.fileSize || 20;
    const fileSizeKB = fileSize * 1024;
    const szfBOCategories = props.config.szfBOCategories;
    const boPreviousParticipationOptions = props.config?.boPreviousParticipationOptions;
    const boHearAboutOptions = props.config?.boHearAboutOptions;
    const {
        boGenericErrorMessage,
        invalidOrEmptyFieldError,
        dropdownChooseOptionMessage,
        maxFileSize,
        fileInvalidMessage,
        szfSuccessModalHeading,
        szfFailModalHeading,
        szfSuccessModalMessage,
        descriptionInvalidMessage,
        multiSelectPlaceholder,
    } = props.resources;
    const handleUpdateAndPromotionLabelChange = (event: MsDyn365.ContentEditableEvent) =>
        (props.config.boUpdateAndPromotionCheckboxLabel = event.target.value);
    const updateAndPromotionLabel = updateAndPromotionCheckboxLabel && (
        <MsDyn365.RichTextComponent
            text={updateAndPromotionCheckboxLabel}
            editProps={{ onEdit: handleUpdateAndPromotionLabelChange, requestContext: props.context.request }}
        />
    );
    const successImageProps = {
        gridSettings: props.context.request.gridSettings ?? {},
        imageSettings: props.config.successModalImage?.imageSettings,
    };
    const failureImageProps = {
        gridSettings: props.context.request.gridSettings ?? {},
        imageSettings: props.config.failModalImage?.imageSettings,
    };
    const imageContainer = { className: 'ms-content-block__image' };
    const successImage = (
        <Node {...imageContainer}>
            <MsDyn365.Image
                {...props.config.successModalImage}
                {...successImageProps}
                requestContext={props.context.request}
                preserveImageSpace={true}
                editProps={{
                    key: props.config.successModalImage ?? {},
                    requestContext: props.context.request,
                    moduleType: props.typeName,
                    imagePropertyName: 'image',
                    moduleId: props.id,
                }}
                shouldSkipToMainImage
            />
        </Node>
    );
    const failureImage = (
        <Node {...imageContainer}>
            <MsDyn365.Image
                {...props.config.failModalImage}
                {...failureImageProps}
                requestContext={props.context.request}
                preserveImageSpace={true}
                editProps={{
                    key: props.config.failModalImage ?? {},
                    requestContext: props.context.request,
                    moduleType: props.typeName,
                    imagePropertyName: 'image',
                    moduleId: props.id,
                }}
                shouldSkipToMainImage
            />
        </Node>
    );

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const name: string = e.target.name;
        const value = e.target.value;
        if (name === 'categories') {
            const IntValue = +value;
            if (multiselectRef && multiselectRef.current && multiselectRef.current.resetSelectedValues) {
                multiselectRef.current?.resetSelectedValues();
            }
            let obj = { ...state, [name]: IntValue, listOfCountryPavilions: [], listOfGovernmentEntities: [], typeOfSponsor: '' };
            switch (IntValue) {
                case 1:
                    obj = {
                        ...obj,
                        enablePavilionsFields: true,
                        enableProductsFields: false,
                        enableRestaurantsFields: false,
                        enableKiosksFields: false,
                        enableServiceFields: false,
                        enableGovernmentEntities: false,
                        enableSponsor: false,
                    };
                    break;
                case 2:
                    obj = {
                        ...obj,
                        enablePavilionsFields: true,
                        enableProductsFields: true,
                        enableRestaurantsFields: false,
                        enableKiosksFields: false,
                        enableServiceFields: false,
                        enableGovernmentEntities: false,
                        enableSponsor: false,
                    };
                    break;
                case 3:
                    obj = {
                        ...obj,
                        enablePavilionsFields: false,
                        enableProductsFields: false,
                        enableRestaurantsFields: true,
                        enableKiosksFields: false,
                        enableServiceFields: false,
                        enableGovernmentEntities: false,
                        enableSponsor: false,
                    };
                    break;
                case 4:
                    obj = {
                        ...obj,
                        enablePavilionsFields: false,
                        enableProductsFields: false,
                        enableRestaurantsFields: false,
                        enableKiosksFields: true,
                        enableServiceFields: false,
                        enableGovernmentEntities: false,
                        enableSponsor: false,
                    };
                    break;
                case 7:
                    obj = {
                        ...obj,
                        enablePavilionsFields: false,
                        enableProductsFields: false,
                        enableRestaurantsFields: false,
                        enableKiosksFields: false,
                        enableServiceFields: true,
                        enableGovernmentEntities: false,
                        enableSponsor: false,
                    };
                    break;
                case 9:
                    obj = {
                        ...obj,
                        enablePavilionsFields: false,
                        enableProductsFields: false,
                        enableRestaurantsFields: false,
                        enableKiosksFields: false,
                        enableServiceFields: false,
                        enableGovernmentEntities: true,
                        enableSponsor: false,
                    };
                    break;
                case 10:
                    obj = {
                        ...obj,
                        enablePavilionsFields: false,
                        enableProductsFields: false,
                        enableRestaurantsFields: false,
                        enableKiosksFields: false,
                        enableServiceFields: false,
                        enableGovernmentEntities: false,
                        enableSponsor: true,
                    };
                    break;
                default:
                    obj = {
                        ...obj,
                        enablePavilionsFields: false,
                        enableProductsFields: false,
                        enableRestaurantsFields: false,
                        enableKiosksFields: false,
                        enableServiceFields: false,
                        enableGovernmentEntities: false,
                        enableSponsor: false,
                    };
                    break;
            }
            setBOInvalidOrEmptyError('');
            setState({...obj,enableCategoriesError: false});
        } else if (name === 'email') {
            const emailPattern: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            if (emailPattern.test(value)) {
                const obj = { ...state, [name]: value, enableEmailError: false };
                setState(obj);
                setBOInvalidOrEmptyError('');
            } else {
                const obj = { ...state, [name]: value, enableEmailError: true };
                setState(obj);
                setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            }
        } else {
            if(name){
                const obj = { ...state, [name]: value, enableFullNameError: false };
                setState(obj);
            }else{
                const obj = { ...state, [name]: value, enableFullNameError: true };
                setState(obj);
                setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            }
        }
    };
    const getbase64 = (imagefile: File, type: string) => {
        const reader = new FileReader();
        reader.readAsDataURL(imagefile);
        reader.onload = () => {
            const result = reader.result;
            const base64 = result?.toString().split('base64,');
            if (type === 'trade') {
                setTradeLicenseFileBase64Code(base64 && base64[1]);
            } else {
                setPresentationFileBase64Code(base64 && base64[1]);
            }
        };
    };
    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            if (e.target.name === 'tradeLicenseFile') {
                if (e.target.files[0] && e.target.files[0].size / 1024 > fileSizeKB) {
                    resetTradeFileField()
                    setState({ ...state, enableTradeLicenseFileError: true });
                } else {
                    setState({ ...state, enableTradeLicenseFileError: false });
                    const imagefile = e.target?.files[0];
                    if (imagefile) {
                        getbase64(imagefile, `trade`);
                        settradeLicenseFile(imagefile);
                    }
                }
            } else {
                if (e.target.files[0] && e.target.files[0].size / 1024 > fileSizeKB) {
                    resetPresentationFileField()
                    setState({ ...state, enablePresentationFileError: true });
                } else {
                    setState({ ...state, enablePresentationFileError: false });
                    const imagefile = e.target?.files[0];
                    if (imagefile) {
                        getbase64(imagefile, `presentation`);
                        setPresentationFile(imagefile);
                    }
                }
            }
        }
    };
    const handleCheckboxChange = (e: any) => {
        const name: string = e.target.name;
        setState({ ...state, [name]: !state.updateNpromotion });
    };
    const checkExistingContact = async (token: string, email: string, phone: string) => {
        const contactExistInput = new GetExistingContactInput(token, email, phone);
        const result = await existingContactDataAction(contactExistInput, props.context.actionContext);
        return result;
    };
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const resetTradeFileField = () => {
        setState({
            ...state,
            enableTradeLicenseFileError: false,
        });
        if (tradeLicenseFileRef.current && tradeLicenseFileRef.current.value) {
            tradeLicenseFileRef.current.value = '';
        }
        settradeLicenseFile(undefined);
        setTradeLicenseFileBase64Code(null);
    };
    const resetPresentationFileField = () => {
        setState({
            ...state,
            enablePresentationFileError: false,
        });
        if (presentationFileRef.current && presentationFileRef.current.value) {
            presentationFileRef.current.value = '';
        }
        setPresentationFile(undefined);
        setPresentationFileBase64Code(null);
    };
    const onSubmitForm = async (e: any): Promise<void> => {
        e.preventDefault();
        const emailPattern: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        if (state.fullName.length <= 0) {
            setState({ ...state, enableFullNameError: true });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('fullName')?.focus();
            return;
        }
        else if (state.email.length <= 0 || !emailPattern.test(state.email)) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('email')?.focus();
            return;
        } else if (!state.phone || state.phone.length < 4 || state.phone.length > 20) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('phone')?.focus();
            return;
        } else if (state.countryCode.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('phone')?.focus();
            return;
        } else if (state.previousParticipant.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('previousParticipant')?.focus();
            return;
        } else if (state.previousParticipant === `1` && state.previousParticipantType.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('previousParticipantType')?.focus();
            return;
        } else if (state.hearAbout.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('hearAbout')?.focus();
            return;
        } else if (state.hearAbout === '5' && state.others.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('others')?.focus();
            return;
        } 
        else if (tradeLicenseFile && tradeLicenseFile?.size && tradeLicenseFile.size / 1024 > fileSizeKB) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            tradeLicenseFileRef?.current?.focus();
            return;
        } 
        else if (presentationFile && presentationFile?.size && presentationFile.size / 1024 > fileSizeKB) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            presentationFileRef?.current?.focus();
            return;
        } else if (state.categories <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('categories')?.focus();
            return;
        } else if ((state.categories === 1 || state.categories === 2) && state.listOfCountryPavilions.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: true,
                enableGovernmentEntitiesError: false,
                enableSponsorError: false
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('listOfCountryPavilions')?.focus();
            return;
        } else if (state.categories === 2 && state.typeOfProducts.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: false,
                enableProductsError: true,
                enableGovernmentEntitiesError: false,
                enableSponsorError: false
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('typeOfProducts')?.focus();
            return;
        } else if (state.categories === 3 && state.typeOfRestaurantsCoffeeShops.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: false,
                enableProductsError: false,
                enableRestaurantsError: true,
                enableGovernmentEntitiesError: false,
                enableSponsorError: false
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('typeOfRestaurantsCoffeeShops')?.focus();
            return;
        } else if (state.categories === 4 && state.typeOfKiosksFoodTrucks.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: false,
                enableProductsError: false,
                enableRestaurantsError: false,
                enableKiosksError: true,
                enableGovernmentEntitiesError: false,
                enableSponsorError: false
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('typeOfKiosksFoodTrucks')?.focus();
            return;
        } else if (state.categories === 4 && state.kioskActivity.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: false,
                enableProductsError: false,
                enableRestaurantsError: false,
                enableKiosksError: false,
                enableKioskActivityError: true,
                enableGovernmentEntitiesError: false,
                enableSponsorError: false
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('kioskActivity')?.focus();
            return;
        } else if (state.categories === 7 && state.serviceActivity.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: false,
                enableProductsError: false,
                enableRestaurantsError: false,
                enableKiosksError: false,
                enableKioskActivityError: false,
                enableServiceError: true,
                enableGovernmentEntitiesError: false,
                enableSponsorError: false
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('serviceActivity')?.focus();
            return;
        } else if (state.categories === 9 && state.listOfGovernmentEntities.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: false,
                enableProductsError: false,
                enableRestaurantsError: false,
                enableKiosksError: false,
                enableKioskActivityError: false,
                enableServiceError: false,
                enableGovernmentEntitiesError: true,
                enableSponsorError: false
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
        } else if (state.categories === 10 && state.typeOfSponsor.length <= 0) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: false,
                enableProductsError: false,
                enableRestaurantsError: false,
                enableKiosksError: false,
                enableKioskActivityError: false,
                enableServiceError: false,
                enableGovernmentEntitiesError: false,
                enableSponsorError: true
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            return;
        } else if (state.description.length <= 0 || state.description.length >= 300) {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: false,
                enableProductsError: false,
                enableRestaurantsError: false,
                enableKiosksError: false,
                enableKioskActivityError: false,
                enableServiceError: false,
                enableDescriptionError: true,
            });
            setBOInvalidOrEmptyError(invalidOrEmptyFieldError);
            setLoading(false);
            document.getElementById('description')?.focus();
            return;
        } else {
            setState({
                ...state,
                enableFullNameError: false,
                enableOrganizationNameError: false,
                enableEmailError: false,
                enablePhoneError: false,
                enablePreviousParticipantError: false,
                enablePreviousParticipantTypeError: false,
                enableHearAboutError: false,
                enableOthersError: false,
                enableTradeLicenseFileError: false,
                enablePresentationFileError: false,
                enableCategoriesError: false,
                enablePavilionsError: false,
                enableProductsError: false,
                enableRestaurantsError: false,
                enableKiosksError: false,
                enableKioskActivityError: false,
                enableServiceError: false,
                enableDescriptionError: false,
            });
        }
        try {
            const mergePhoneWithCountryCode = `${state.countryCode}${state.phone}`;
            const firstName = state.fullName.substring(0, state.fullName.indexOf(' '));
            const lastName = state.fullName.substring(state.fullName.indexOf(' ') + 1);
            const CRMtoken = (await props.data.crmToken)?.token || undefined;
            const isContactAlreadyExist = await checkExistingContact(CRMtoken, state.email, mergePhoneWithCountryCode);
            if (isContactAlreadyExist.status) {
                const input: IPostBOInput = {
                    ...state,
                    tradeLicenseFile,
                    presentationFile,
                    tradeLicensefileBase64Code,
                    presentationfileBase64Code,
                    CRMtoken,
                    contactID: isContactAlreadyExist.id,
                };
                const createCaseInput = new PostBusinessOpCaseInput(input);
                const createCaseResponse = await BOCaseDataAction(createCaseInput, props.context.actionContext);
                if (createCaseResponse.status) {
                    resetForm();
                    setLoading(false);
                    setIsModalOpen(true);
                } else {
                    setBOError(boGenericErrorMessage);
                    setLoading(false);
                    setIsModalOpen(true);
                }
            } else {
                const createInputData: INewContactCreation = {
                    firstName: firstName,
                    lastName: lastName,
                    email: state.email,
                    phone: `${state.phone}`,
                    countryCode: `${state.countryCode}`,
                    updateNpromotion: state.updateNpromotion,
                };
                const createContactInput = new PostNewContactInput(CRMtoken, createInputData);
                const createNewContactResponse = await createNewContactDataAction(createContactInput, props.context.actionContext);
                if (createNewContactResponse.status) {
                    const input: IPostBOInput = {
                        ...state,
                        tradeLicenseFile,
                        presentationFile,
                        tradeLicensefileBase64Code,
                        presentationfileBase64Code,
                        CRMtoken,
                        contactID: createNewContactResponse.id,
                    };
                    const createCaseInput = new PostBusinessOpCaseInput(input);
                    const createCaseResponse = await BOCaseDataAction(createCaseInput, props.context.actionContext);
                    if (createCaseResponse.status) {
                        resetForm();
                        setLoading(false);
                        setIsModalOpen(true);
                    } else {
                        setLoading(false);
                        setBOError(boGenericErrorMessage);
                        setIsModalOpen(true);
                    }
                } else {
                    setLoading(false);
                    setBOError(createNewContactResponse.msg ? createNewContactResponse.msg : boGenericErrorMessage);
                    setIsModalOpen(true);
                }
            }
            setLoading(false);
        } catch (error) {
            setBOError(boGenericErrorMessage);
            setLoading(false);
            setIsModalOpen(true);
            console.log('error', error);
        }
    };
    const resetForm = () => {
        setState({
            ...state,
            fullName: '',
            organizationName: '',
            email: '',
            countryCode: '971',
            phone: '',
            previousParticipant: '',
            previousParticipantType: '',
            hearAbout: '',
            others: '',
            categories: 0,

            enableFullNameError: false,
            enableOrganizationNameError: false,
            enableEmailError: false,
            enablePhoneError: false,
            enablePreviousParticipantError: false,
            enablePreviousParticipantTypeError: false,
            enableHearAboutError: false,
            enableOthersError: false,
            enableTradeLicenseFileError: false,
            enablePresentationFileError: false,
            enableCategoriesError: false,

            enablePavilionsFields: false,
            enableProductsFields: false,
            enableGovernmentEntities: false,
            enableSponsor: false,
            enableRestaurantsFields: false,
            enableKiosksFields: false,
            enableServiceFields: false,
            listOfCountryPavilions: [],
            typeOfProducts: [],
            listOfGovernmentEntities: [],
            typeOfSponsor: '',
            typeOfRestaurantsCoffeeShops: '',
            typeOfKiosksFoodTrucks: '',
            kioskActivity: '',
            serviceActivity: '',

            enableGovernmentEntitiesError: false,
            enableSponsorError: false,
            enablePavilionsError: false,
            enableProductsError: false,
            enableRestaurantsError: false,
            enableKiosksError: false,
            enableKioskActivityError: false,
            enableServiceError: false,
            enableDescriptionError: false,
            description: '',
            updateNpromotion: false,
        });
        if (tradeLicenseFileRef.current && tradeLicenseFileRef.current.value) {
            tradeLicenseFileRef.current.value = '';
        }
        if (presentationFileRef.current && presentationFileRef.current.value) {
            presentationFileRef.current.value = '';
        }
        settradeLicenseFile(undefined);
        setPresentationFile(undefined);
        setTradeLicenseFileBase64Code(null);
        setPresentationFileBase64Code(null);
        setBOError('');
    };
    const getSubCategories = (szfBOCategories: ISzfBOCategoriesData[] | undefined, categories: number, type: number) => {
        const foundCategory = szfBOCategories?.find((categoryItem) => categories === categoryItem.value);
        if (categories === 1 || categories === 2 || categories === 9 || categories === 10) {
            if (type === 1) {
                const subcategoryList = foundCategory?.subCategory1?.map((SCoptionItem, i) => {
                    return {
                        name: SCoptionItem.linkText,
                        value: i + 1,
                        id: `subcategory-${i}`,
                    };
                });
                return subcategoryList;
            } else {
                const subcategoryList = foundCategory?.subCategory2?.map((SCoptionItem, i) => {
                    return {
                        name: SCoptionItem.linkText,
                        value: SCoptionItem.value,
                        id: `subcategory-${i}`,
                    };
                });
                return subcategoryList;
            }
        } else {
            return [];
        }
    };
    const getRestaurantSubcategory = (szfBOCategories: ISzfBOCategoriesData[] | undefined, categories: number) => {
        const foundCategory = szfBOCategories?.find((categoryItem) => categories === categoryItem.value);
        const subcategoryList = foundCategory?.subCategory1?.map((SCoptionItem, i) => {
            return (
                <option key={`business-op-resturantandcoffeeshops-options-${i}`} value={SCoptionItem.value}>
                    {SCoptionItem.linkText}
                </option>
            );
        });
        return subcategoryList;
    };
    const getSponsorcategory = (szfBOCategories: ISzfBOCategoriesData[] | undefined, categories: number) => {
        const foundCategory = szfBOCategories?.find((categoryItem) => categories === categoryItem.value);
        const subcategoryList = foundCategory?.subCategory1?.map((SCoptionItem, i) => {
            return (
                <option key={`business-op-resturantandcoffeeshops-options-${i}`} value={SCoptionItem.linkText}>
                    {SCoptionItem.linkText}
                </option>
            );
        });
        return subcategoryList;
    };
    const SetPavilionState = (selectedList: IPavilionsOptionType[]) => {
        const filteredSelectedList = selectedList.map((selectedOption) => {
            return selectedOption.name;
        });
        setState({
            ...state,
            listOfCountryPavilions: filteredSelectedList,
        });
    };
    const SetProductsState = (selectedList: IPavilionsOptionType[]) => {
        const filteredSelectedList = selectedList.map((selectedOption) => {
            return selectedOption.value;
        });
        setState({
            ...state,
            typeOfProducts: filteredSelectedList,
        });
    };
    const SetGovernmentEntitiesState = (selectedList: IPavilionsOptionType[]) => {
        const filteredSelectedList = selectedList.map((selectedOption) => {
            return selectedOption.name;
        });
        setState({
            ...state,
            listOfGovernmentEntities: filteredSelectedList,
        });
    };
    const onSelect = (selectedList: IPavilionsOptionType[], selectedItem: IPavilionsOptionType) => {
        SetPavilionState(selectedList);
    };
    const onRemove = (selectedList: IPavilionsOptionType[], removedItem: IPavilionsOptionType) => {
        SetPavilionState(selectedList);
    };
    const onProductSelect = (selectedList: IPavilionsOptionType[], selectedItem: IPavilionsOptionType) => {
        SetProductsState(selectedList);
    };
    const onProductRemove = (selectedList: IPavilionsOptionType[], removedItem: IPavilionsOptionType) => {
        SetProductsState(selectedList);
    };
    const onGovernmentEntitiesSelect = (selectedList: IPavilionsOptionType[], selectedItem: IPavilionsOptionType) => {
        SetGovernmentEntitiesState(selectedList);
    };
    const onGovernmentEntitiesRemove = (selectedList: IPavilionsOptionType[], removedItem: IPavilionsOptionType) => {
        SetGovernmentEntitiesState(selectedList);
    };
    const renderInvalidOrEmptyMessage = (type?: string) => {
        if (type === 'custom') {
            return <div className='invalid-feedback'>{BOInvalidOrEmptyError && BOInvalidOrEmptyError}</div>;
        } else if (type === 'file') {
            return <FormFeedback>{fileInvalidMessage && fileInvalidMessage}</FormFeedback>;
        } else if (type === 'description') {
            return <FormFeedback>{descriptionInvalidMessage && descriptionInvalidMessage}</FormFeedback>;
        } else {
            return <FormFeedback>{BOInvalidOrEmptyError && BOInvalidOrEmptyError}</FormFeedback>;
        }
    };
    const handlePhoneCountryCodeOnChange = (value: string, country: IcountryCodeInput) => {
        const countryCode = country.dialCode;
        const startsWithCountryCode = value.startsWith(countryCode);
        const newPhone = startsWithCountryCode ? value.slice(countryCode.length) : value;
    
        setState({
            ...state,
            phone: newPhone,
            countryCode: countryCode,
        });
    };
    const renderCountrySubCategoryField = () => {
        if (state.categories && state.categories > 0 && state.enablePavilionsFields) {
            return (
                <div className='multiSelect-container-div'>
                    <Label for='szf-subcategory'>
                        {state.enableProductsFields
                            ? boShopCountryPavilionsLabel && boShopCountryPavilionsLabel
                            : boOrganizeCountryPavilionsLabel && boOrganizeCountryPavilionsLabel}
                        {/* *List the country pavilion name(s) which you are interested to organize (You can select multiple) */}
                    </Label>
                    <Multiselect
                        id={`szf-subcategory`}
                        placeholder={state.listOfCountryPavilions.length > 0 ? '' : multiSelectPlaceholder}
                        options={getSubCategories(szfBOCategories, state.categories, 1)} // Options to display in the dropdown
                        // selectedValues={} // Preselected value to persist in dropdown
                        onSelect={onSelect} // Function will trigger on select event
                        onRemove={onRemove} // Function will trigger on remove event
                        displayValue='name' // Property name to display in the dropdown options
                        ref={multiselectRef}
                        disable={loading}
                    />
                    {state.enablePavilionsError && renderInvalidOrEmptyMessage('custom')}
                </div>
            );
        } else {
            return null;
        }
    };
    const renderProductSubCategoryField = () => {
        if (state.categories && state.categories > 0 && state.enableProductsFields) {
            return (
                <div className='multiSelect-container-div'>
                    <Label for='szf-subcategory'>
                        {boProductTypeLabel && boProductTypeLabel}
                        {/* *What type of products are you interested to showcase in the desired pavilion? &nbsp;  &nbsp;  */}
                    </Label>
                    <Multiselect
                        id={`szf-subcategory`}
                        placeholder={state.typeOfProducts.length > 0 ? '' : multiSelectPlaceholder}
                        options={getSubCategories(szfBOCategories, state.categories, 2)} // Options to display in the dropdown
                        // selectedValues={} // Preselected value to persist in dropdown
                        onSelect={onProductSelect} // Function will trigger on select event
                        onRemove={onProductRemove} // Function will trigger on remove event
                        displayValue='name' // Property name to display in the dropdown options
                        // ref={multiselectRef}
                        disable={loading}
                    />
                    {state.enableProductsError && renderInvalidOrEmptyMessage('custom')}
                </div>
            );
        } else {
            return null;
        }
    };
    const renderGovernmentEntitiesField = () => {
        if (state.categories && state.categories > 0 && state.enableGovernmentEntities) {
            return (
                <div className='multiSelect-container-div govt-category'>
                    <Label for='szf-subcategory'>
                        {governmentEntitiesLabel && governmentEntitiesLabel}
                        {/* *List the country pavilion name(s) which you are interested to organize (You can select multiple) */}
                    </Label>
                    <Multiselect
                        id={`szf-subcategory`}
                        placeholder={state.listOfGovernmentEntities.length > 0 ? '' : multiSelectPlaceholder}
                        options={getSubCategories(szfBOCategories, state.categories, 1)} // Options to display in the dropdown
                        // selectedValues={} // Preselected value to persist in dropdown
                        onSelect={onGovernmentEntitiesSelect} // Function will trigger on select event
                        onRemove={onGovernmentEntitiesRemove} // Function will trigger on remove event
                        displayValue='name' // Property name to display in the dropdown options
                        ref={multiselectRef}
                        disable={loading}
                    />
                    {state.enableGovernmentEntitiesError && renderInvalidOrEmptyMessage('custom')}
                </div>
            );
        } else {
            return null;
        }
    };
    const renderSponsorField = () => {
        if (state.categories && state.categories > 0 && state.enableSponsor) {
            return (
                <FormGroup floating className="form-floating">
                    <Input
                        type='select'
                        name='typeOfSponsor'
                        placeholder={`Sponsor`}
                        id='typeOfSponsor'
                        value={state.typeOfSponsor}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            onChangeHandler(event);
                        }}
                        invalid={state.enableSponsorError}
                        className='form-control'
                        required
                        disabled={loading}
                    >
                        <option
                            key={`business-op-resturantandcoffeeshops-options-00`}
                            value={''}
                        >{`${dropdownChooseOptionMessage}`}</option>
                        {getSponsorcategory(szfBOCategories, state.categories)}
                    </Input>
                    <Label for='typeOfSponsor'>
                        {/* Restaurants and Coffee Shops */}
                        {sponsorLabel && sponsorLabel}
                    </Label>
                    {state.enableSponsorError && renderInvalidOrEmptyMessage()}
                </FormGroup>
            );
        } else {
            return null;
        }
    };
    const renderRestaurantField = () => {
        if (state.categories && state.categories > 0 && state.enableRestaurantsFields) {
            return (
                <FormGroup floating className="form-floating">
                    <Input
                        type='select'
                        name='typeOfRestaurantsCoffeeShops'
                        placeholder={`Restaurants & Coffee Shops`}
                        id='typeOfRestaurantsCoffeeShops'
                        value={state.typeOfRestaurantsCoffeeShops}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            onChangeHandler(event);
                        }}
                        invalid={state.enableRestaurantsError}
                        className='form-control'
                        required
                        disabled={loading}
                    >
                        <option
                            key={`business-op-resturantandcoffeeshops-options-00`}
                            value={''}
                        >{`${dropdownChooseOptionMessage}`}</option>
                        {getRestaurantSubcategory(szfBOCategories, state.categories)}
                    </Input>
                    <Label for='typeOfRestaurantsCoffeeShops'>
                        {/* Restaurants and Coffee Shops */}
                        {boRestaurantShopTypeLabel && boRestaurantShopTypeLabel}
                    </Label>
                    {state.enableRestaurantsError && renderInvalidOrEmptyMessage()}
                </FormGroup>
            );
        } else {
            return null;
        }
    };
    const renderKiosksFields = () => {
        if (state.categories && state.categories > 0 && state.enableKiosksFields) {
            return (
                <>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='select'
                            name='typeOfKiosksFoodTrucks'
                            placeholder={`Kiosks & Food Trucks`}
                            id='typeOfKiosksFoodTrucks'
                            value={state.typeOfKiosksFoodTrucks}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            className='form-control'
                            invalid={state.enableKiosksError}
                            required
                            disabled={loading}
                        >
                            <option
                                key={`business-op-resturantandcoffeeshops-options-00`}
                                value={''}
                            >{`${dropdownChooseOptionMessage}`}</option>
                            {getRestaurantSubcategory(szfBOCategories, state.categories)}
                        </Input>
                        <Label for='typeOfKiosksFoodTrucks'>
                            {/* Kiosks and Food Trucks */}
                            {boKiosksTypeLabel && boKiosksTypeLabel}
                        </Label>
                        {state.enableKiosksError && renderInvalidOrEmptyMessage()}
                    </FormGroup>
                    <FormGroup floating className='contact-us-textarea form-floating'>
                        <Input
                            type='textarea'
                            name='kioskActivity'
                            placeholder='kiosk Activity'
                            id='kioskActivity'
                            value={state.kioskActivity}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            invalid={state.enableKioskActivityError}
                            className='form-control'
                            required
                            disabled={loading}
                        />
                        <Label for='kioskActivity'>
                            {/* kioskActivity */}
                            {boKiosksActivityLabel && boKiosksActivityLabel}
                        </Label>
                        {state.enableKioskActivityError && renderInvalidOrEmptyMessage()}
                    </FormGroup>
                </>
            );
        } else {
            return null;
        }
    };
    const renderServiceField = () => {
        if (state.categories && state.categories > 0 && state.enableServiceFields) {
            return (
                <FormGroup floating className='contact-us-textarea form-floating'>
                    <Input
                        type='textarea'
                        name='serviceActivity'
                        placeholder='Service Activity'
                        id='serviceActivity'
                        value={state.serviceActivity}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            onChangeHandler(event);
                        }}
                        invalid={state.enableServiceError}
                        className='form-control'
                        required
                        disabled={loading}
                    />
                    <Label for='serviceActivity'>{boServiceActivityLabel && boServiceActivityLabel}</Label>
                    {state.enableServiceError && renderInvalidOrEmptyMessage()}
                </FormGroup>
            );
        } else {
            return null;
        }
    };
    return (
        <>
            <div className='contact-left'>
                <p>{props.resources.bOParagraph}</p>
                <SZFModal
                    isOpen={isModalOpen}
                    onModalToggle={toggleModal}
                    className={'status-modal'}
                    modalTitle={
                        <>
                            <h3>{BOError ? szfFailModalHeading : szfSuccessModalHeading}</h3>
                            <button onClick={toggleModal} className='modal-close-btn'>
                                <img
                                    src='https://images-ap-prod.cms.commerce.dynamics.com/cms/api/rwrswxpkjb/imageFileData/MB2jbv?pubver=0'
                                    alt=''
                                />
                            </button>
                        </>
                    }
                    modalBody={
                        isModalOpen ? (
                            <div className='szf-modal-body'>
                                {BOError ? failureImage : successImage}
                                <h4>{BOError ? BOError : szfSuccessModalMessage}</h4>
                            </div>
                        ) : null
                    }
                />
                <Form onSubmit={onSubmitForm}>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='text'
                            name='fullName'
                            id='fullName'
                            placeholder='Full Name*'
                            value={state.fullName}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            className='form-control'
                            invalid={state.enableFullNameError}
                            required
                            disabled={loading}
                        />
                        <Label for='fullName'>
                            {/* Full Name */}
                            {boFullnameLabel && boFullnameLabel}
                        </Label>
                        {state.enableFullNameError && renderInvalidOrEmptyMessage()}
                    </FormGroup>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='text'
                            name='organizationName'
                            id='organizationName'
                            placeholder='Organization Name*'
                            value={state.organizationName}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            className='form-control'
                            // invalid={state.enableOrganizationNameError}
                            // required
                            disabled={loading}
                        />
                        <Label for='organizationName'>
                            {/* Full Name */}
                            {boOrganizationNameLabel && boOrganizationNameLabel}
                        </Label>
                        {/* {state.enableOrganizationNameError && renderInvalidOrEmptyMessage()} */}
                    </FormGroup>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='email'
                            name='email'
                            id='email'
                            placeholder='Email'
                            value={state.email}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            className='form-control'
                            invalid={state.enableEmailError}
                            required
                            disabled={loading}
                        />
                        <Label for='email'>
                            {/* Email */}
                            {boEmailLabel && boEmailLabel}
                        </Label>
                        {state.enableEmailError && renderInvalidOrEmptyMessage()}
                    </FormGroup>
                    <div className='phone-group'>
                        <Label for='phone'>{boPhoneLabel && boPhoneLabel}</Label>
                        {locale.toLowerCase() === 'ar-ae' ? (
                            <PhoneInput
                                inputProps={{
                                    id: `phone`,
                                    name: 'phone',
                                    required: true,
                                    placeholder: `+971 5# ### ###`
                                }}
                                country={'ae'}
                                enableAreaCodes={true}
                                localization={arabicLocale}
                                inputClass={state.enablePhoneError ? 'invalidphone' : ''}
                                value={`${state.countryCode}${state.phone}`}
                                // placeholder={ `+971 5# ### ###`}
                                autoFormat={true}
                                enableSearch={true}
                                disabled={loading}
                                onChange={handlePhoneCountryCodeOnChange}
                            />
                        ) : (
                            <PhoneInput
                                inputProps={{
                                    id: `phone`,
                                    name: 'phone',
                                    required: true,
                                    placeholder: `+971 5# ### ###`
                                }}
                                country={'ae'}
                                enableAreaCodes={true}
                                inputClass={state.enablePhoneError ? 'invalidphone' : ''}
                                value={`${state.countryCode}${state.phone}`}
                                autoFormat={true}
                                enableSearch={true}
                                disabled={loading}
                                onChange={handlePhoneCountryCodeOnChange}
                            />
                        )}
                        {state.enablePhoneError && renderInvalidOrEmptyMessage('custom')}
                    </div>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='select'
                            name='previousParticipant'
                            placeholder='Previous Participant'
                            id='previousParticipant'
                            value={state.previousParticipant}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            className='form-control'
                            invalid={state.enablePreviousParticipantError}
                            required
                            disabled={loading}
                        >
                            <option
                                key={`business-op-previous-participant-options-00`}
                                value={''}
                            >{`${dropdownChooseOptionMessage}`}</option>
                            {boPreviousParticipationOptions &&
                                boPreviousParticipationOptions?.map((PPoptionItem, i) => {
                                    return (
                                        <option key={`business-op-previous-participant-options-${i}`} value={PPoptionItem.value}>
                                            {PPoptionItem.linkText}
                                        </option>
                                    );
                                })}
                        </Input>
                        <Label for='previousParticipant'>{boPreviousParticipationSelectLabel && boPreviousParticipationSelectLabel}</Label>
                        {state.enablePreviousParticipantError && renderInvalidOrEmptyMessage()}
                    </FormGroup>
                    {state.previousParticipant && state.previousParticipant === `1` && (
                        <FormGroup floating className="form-floating">
                            <Input
                                type='text'
                                name='previousParticipantType'
                                id='previousParticipantType'
                                placeholder='Previous Participant Type*'
                                value={state.previousParticipantType}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    onChangeHandler(event);
                                }}
                                className='form-control'
                                invalid={state.enablePreviousParticipantTypeError}
                                required
                                disabled={loading}
                            />
                            <Label for='previousParticipantType'>
                                {boPreviousParticipationTypeLabel && boPreviousParticipationTypeLabel}
                            </Label>
                            {state.enablePreviousParticipantTypeError && renderInvalidOrEmptyMessage()}
                        </FormGroup>
                    )}
                    <FormGroup floating className="form-floating">
                        <Input
                            type='select'
                            name='hearAbout'
                            placeholder='hearAbout'
                            id='hearAbout'
                            value={state.hearAbout}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            invalid={state.enableHearAboutError}
                            className='form-control'
                            required
                            disabled={loading}
                        >
                            <option key={`business-op-hear-about-options-00`} value={''}>{`${dropdownChooseOptionMessage}`}</option>
                            {boHearAboutOptions &&
                                boHearAboutOptions?.map((HAoptionItem, i) => {
                                    return (
                                        <option key={`business-op-hear-about-options-${i}`} value={HAoptionItem.value}>
                                            {HAoptionItem.linkText}
                                        </option>
                                    );
                                })}
                        </Input>
                        <Label for='hearAbout'>{boHearAboutSelectLabel && boHearAboutSelectLabel}</Label>
                        {state.enableHearAboutError && renderInvalidOrEmptyMessage()}
                    </FormGroup>
                    {state.hearAbout && state.hearAbout === '5' && (
                        <FormGroup floating className="form-floating">
                            <Input
                                type='text'
                                name='others'
                                id='others'
                                placeholder='Others*'
                                value={state.others}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    onChangeHandler(event);
                                }}
                                className='form-control'
                                invalid={state.enableOthersError}
                                required
                                disabled={loading}
                            />
                            <Label for='others'>
                                {/* Full Name */}
                                {boOtherLabel && boOtherLabel}
                            </Label>
                            {state.enableOthersError && renderInvalidOrEmptyMessage()}
                        </FormGroup>
                    )}
                    <FormGroup floating className='business-op-tradeLicenseFile-formgroup form-floating'>
                        <InputGroup>
                            <Input
                                type='file'
                                name='tradeLicenseFile'
                                id='tradeLicenseFile'
                                innerRef={tradeLicenseFileRef}
                                invalid={state.enableTradeLicenseFileError}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    handleFileChange(event);
                                }}
                                className='form-control business-op-tradeLicenseFile'
                                disabled={loading}
                            />
                            <Button
                                onClick={() => {
                                    resetTradeFileField();
                                }}
                            >
                                x
                            </Button>
                            <Label for='tradeLicenseFile'>{boTradeLicenseFileLabel && boTradeLicenseFileLabel}</Label>
                            {maxFileSize && (
                                <div className='file-size-info'>
                                    <div className='info-icon'>
                                        <img
                                            src='https://images-ap-prod.cms.commerce.dynamics.com/cms/api/rwrswxpkjb/imageFileData/MB2lGx?pubver=0'
                                            alt=''
                                        />
                                    </div>
                                    <p>{maxFileSize}</p>
                                </div>
                            )}
                            {state.enableTradeLicenseFileError && renderInvalidOrEmptyMessage('file')}
                        </InputGroup>
                    </FormGroup>
                    <FormGroup floating className='contact-us-file-formgroup form-floating'>
                        <InputGroup>
                            <Input
                                type='file'
                                name='presentationFile'
                                id='presentationFile'
                                innerRef={presentationFileRef}
                                invalid={state.enablePresentationFileError}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    handleFileChange(event);
                                }}
                                className='form-control contact-us-file'
                                disabled={loading}
                            />
                            <Button
                                onClick={() => {
                                    resetPresentationFileField();
                                }}
                            >
                                x
                            </Button>
                            <Label for='presentationFile'>
                                {/* What would you like to add image? (Optional) */}
                                {boPresentationFileLabel && boPresentationFileLabel}
                            </Label>
                            {maxFileSize && (
                                <div className='file-size-info'>
                                    <div className='info-icon'>
                                        <img
                                            src='https://images-ap-prod.cms.commerce.dynamics.com/cms/api/rwrswxpkjb/imageFileData/MB2lGx?pubver=0'
                                            alt=''
                                        />
                                    </div>
                                    <p>{maxFileSize}</p>
                                </div>
                            )}
                            {state.enablePresentationFileError && renderInvalidOrEmptyMessage('file')}
                        </InputGroup>
                    </FormGroup>
                    <FormGroup floating className="form-floating">
                        <Input
                            type='select'
                            name='categories'
                            placeholder='choose Category'
                            id='categories'
                            value={state.categories}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            invalid={state.enableCategoriesError}
                            className='form-control'
                            required
                            disabled={loading}
                        >
                            <option key={`business-op-categories-options-00`} value={''}>{`${dropdownChooseOptionMessage}`}</option>
                            {szfBOCategories &&
                                szfBOCategories?.map((HAoptionItem, i) => {
                                    return (
                                        <option key={`business-op-categories-options-${i}`} value={HAoptionItem.value}>
                                            {HAoptionItem.linkText}
                                        </option>
                                    );
                                })}
                        </Input>
                        <Label for='categories'>{boCategoriesSelectLabel && boCategoriesSelectLabel}</Label>
                        {state.enableCategoriesError && renderInvalidOrEmptyMessage()}
                    </FormGroup>
                    {renderCountrySubCategoryField()}
                    {renderProductSubCategoryField()}
                    {renderGovernmentEntitiesField()}
                    {renderSponsorField()}
                    {renderRestaurantField()}
                    {renderKiosksFields()}
                    {renderServiceField()}
                    <FormGroup floating className='contact-us-textarea form-floating'>
                        <Input
                            type='textarea'
                            name='description'
                            placeholder='Please share details here...'
                            id='description'
                            value={state.description}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChangeHandler(event);
                            }}
                            invalid={state.enableDescriptionError}
                            className='form-control'
                            required
                            disabled={loading}
                        />
                        <Label for='description'>{boDescriptionLabel && boDescriptionLabel}</Label>
                        {state.enableDescriptionError && renderInvalidOrEmptyMessage('description')}
                    </FormGroup>
                    <FormGroup check>
                        <Label check className='custom-checkbox'>
                            {updateAndPromotionLabel}
                            <Input
                                type='checkbox'
                                id='updateNpromotion'
                                name='updateNpromotion'
                                defaultChecked={state.updateNpromotion}
                                checked={state.updateNpromotion}
                                onChange={(event: any) => {
                                    handleCheckboxChange(event);
                                }}
                                className='form-control'
                                disabled={loading}
                            />
                            <span className='checkmark'></span>
                        </Label>
                    </FormGroup>
                    <Button
                        type='button'
                        className='btn'
                        onClick={(e:any) => {
                            setLoading(true);
                            onSubmitForm(e);
                        }}
                        disabled={loading}
                    >
                        {loading && (
                            <>
                                <MoonLoader size={15} color="#fff" />
                            </>
                        )}
                        {boSubmitButtonLabel && boSubmitButtonLabel}
                    </Button>
                </Form>
            </div>
        </>
    );
};
